const countryCodeList = [
  {
    areaId: 25,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 26,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 27,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 28,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 223,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 29,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 30,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 31,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 32,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 33,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 34,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 35,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 36,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 37,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 38,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 39,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 0,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 40,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 41,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 42,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 43,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 44,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 45,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 1,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 46,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 47,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 48,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 49,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 50,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 51,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 52,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 53,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 54,
    url: 'https://www.hikvision.com/pt-br/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 224,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 55,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 56,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 57,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 58,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 59,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 60,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 61,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 24,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 62,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 63,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 64,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 65,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 66,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 67,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 68,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 69,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 70,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 71,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 72,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 73,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 2,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 74,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 75,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 3,
    url: 'https://www.hikvision.com/cz/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 4,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 76,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 77,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 78,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 79,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 80,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 81,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 82,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 83,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 84,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 85,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 86,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 87,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 228,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 88,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 5,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 6,
    url: 'https://www.hikvision.com/fr/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 89,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 90,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 91,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 92,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 93,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 7,
    url: 'https://www.hikvision.com/de/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 94,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 289,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 8,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 95,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 96,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 97,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 222,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 98,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 99,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 100,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 101,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 102,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 103,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 104,
    url: 'https://www.hikvision.com/hk/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/hk/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 9,
    url: 'https://www.hikvision.com/hu/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 105,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 106,
    url: 'https://www.hikvisionindia.com/',
    cloudUrl: 'https://www.hikvisionindia.com/'
  },
  {
    areaId: 107,
    url: 'https://www.hikvision.com/id/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 108,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 109,
    url: 'https://www.hikvision.com/uk/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 110,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 10,
    url: 'https://www.hikvision.com/it/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 111,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 112,
    url: 'https://www.hikvision.com/jp/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 113,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 114,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 115,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 116,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 117,
    url: 'https://www.hikvision.com/korean/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 118,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 119,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 120,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 121,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 122,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 123,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 124,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 125,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 126,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 127,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 128,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 129,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 130,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 131,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 132,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 133,
    url: 'https://www.hikvision.com/content/hikvision/en/products/software/hik-proconnect.html',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 135,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 134,
    url: 'https://www.hikvision.com/my/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/my/Solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 136,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 137,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 138,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 139,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 140,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 141,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 142,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 226,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 143,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 144,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 145,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 146,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 147,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 148,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 149,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 150,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 151,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 152,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 153,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 154,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 11,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 155,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 156,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 157,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 158,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 159,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 292,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 290,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 221,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 12,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 160,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 161,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 163,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 162,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 164,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 165,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 166,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 167,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 168,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 169,
    url: 'https://www.hikvision.com/ph/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 13,
    url: 'https://www.hikvision.com/pl/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 14,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 170,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 171,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 15,
    url: 'https://www.hikvision.com/ro/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 172,
    url: 'https://hikvision.ru/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 173,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 174,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 227,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 175,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 176,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 177,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 178,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 179,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 180,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 181,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 182,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 183,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 184,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 16,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 185,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 186,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/'
  },
  {
    areaId: 187,
    url: 'https://www.hikvision.com/sg/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/sg/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 188,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/'
  },
  {
    areaId: 17,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 18,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 291,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 189,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 190,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 19,
    url: 'https://www.hikvision.com/es/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 191,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 225,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 192,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 193,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 20,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 21,
    url: 'https://www.hikvision.com/europe/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 296,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 196,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 194,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 195,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 197,
    url: 'https://www.hikvision.com/th/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/th/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 198,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 199,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 295,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 200,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 201,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 202,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 203,
    url: 'https://www.hikvision.com/tr/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/tr/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 204,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 205,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 294,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 206,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 207,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 208,
    url: 'https://www.hikvision.com/ar/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/ar/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 22,
    url: 'https://www.hikvision.com/uk',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 23,
    url: 'https://us.hikvision.com/en',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 210,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 211,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 212,
    url: 'https://www.hikvision.com/au-en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 213,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 214,
    url: 'https://www.hikvision.com/es-la/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 215,
    url: 'https://www.hikvision.com/vn/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 216,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 217,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 293,
    url: 'https://www.hikvision.com/en/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 218,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 219,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 220,
    url: 'https://www.hikvision.com/africa/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/africa/solutions/hosted-service-solution/cloud-based-access---attendance-solution/'
  },
  {
    areaId: 308,
    url: 'https://www.hikvision.com/mena-en/products/software/hik-proconnect/',
    cloudUrl:
      'https://www.hikvision.com/mena-en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  },
  {
    areaId: 309,
    url: 'https://www.hikvision.com/fr/products/software/hik-proconnect/',
    cloudUrl: 'https://www.hikvision.com/en/solutions/hosted-service-solution/cloud-based-access-attendance-solution/'
  }
];

export default countryCodeList;
